module.exports = __webpack_public_path__ + "static/media/smallLogo.503fdd52.svg";